<template>
  <div class="user_list">
    <div v-if="city" class="city">
      <span>
<svg t="1600322779368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9296" width="25" height="25"><path d="M550.9 390.8L340.5 559.5V780c0 23.2 22.7 42.1 50.7 42.1H745c28 0 50.7-18.8 50.7-42.1V559.5L585.4 390.8c-9.8-7.6-24.7-7.6-34.5 0z" fill="#E8CB3A" p-id="9297"></path><path d="M601.5 853.8H401.9V567.2c0-44.6 36.3-81 81-81h42c42.3 0 76.7 34.4 76.7 76.7v290.9z m-165.3-34.3h131V562.9c0-23.4-19-42.4-42.4-42.4h-42c-25.7 0-46.6 20.9-46.6 46.6v252.4zM801.1 345.9V207c0-14.8-12-26.8-26.8-26.8h-26.2c-16.4 0-29.7 13.3-29.7 29.7v65.9l82.7 70.1z" fill="#A53B24" p-id="9298"></path><path d="M149.6 552.7c-17.4 0-34.2-5.7-46.9-17.4-12.5-11.5-19.5-27.4-19.5-44.8 0-20.6 9.8-41.4 26.7-56.9l340.6-289.5c3.9-3.6 8.7-7.2 14-10.4 12.1-8.9 27-13.5 43.5-13 16.5-0.5 31.5 4.1 43.5 13 5.3 3.2 10.2 6.8 14.5 10.8l340.1 289.1c17 15.5 26.7 36.3 26.7 57 0 17.4-6.9 33.3-19.5 44.8-27.9 25.5-74.7 22.6-106.7-6.7L528 291.7c-11.6-9.8-28.3-9.8-39.9 0L208.9 529.1c-17.1 15.6-38.7 23.6-59.3 23.6zM506.1 155c-8.5 0-15.9 2.3-21.6 6.6l-1.7 1.1c-3.6 2.1-6.8 4.5-9.6 7.1L132.6 459.3c-9.4 8.6-15.1 20.2-15.1 31.2 0 5.4 1.4 13.2 8.3 19.4 14.4 13.2 42 10.1 60.4-6.7l279.7-237.8c24.4-20.8 59.9-20.8 84.3 0l279.3 237.4c18.8 17.2 46.5 20.2 60.9 7.1 6.9-6.3 8.3-14 8.3-19.4 0-11-5.6-22.4-15.4-31.4L543.4 170.2c-3.3-3-6.5-5.3-10.1-7.5l-1.7-1.1c-6-4.6-13.9-6.8-23.1-6.6h-2.4z" fill="#050505" p-id="9299"></path><path d="M738.2 853.5H277.9c-45.9 0-83.2-32.3-83.2-71.9V495.3L475 261.6c19.1-14.7 46.8-14.7 65.9 0l280.3 233.7v286.3c0.2 39.7-37.1 71.9-83 71.9zM229.1 511.4v270.3c0 20.7 21.9 37.6 48.8 37.6h460.3c26.9 0 48.8-16.9 48.8-37.6V511.4l-267.5-223c-6-4.6-16.7-4.7-23.3 0.2L229.1 511.4z" fill="#050505" p-id="9300"></path></svg>
    供暖费
   </span>
      <span>
        {{city}}
      </span>
    </div>
    <el-card v-if="name&&state=='huilian'" class="box-card1">
      <li v-if="name&&state=='huilian'" @click="goBind" class="cell_item">
        <p class="title_tip">
          <span class="cell_label">
            <svg
              t="1600062811852"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1871"
              width="25"
              height="25"
            >
              <path
                d="M182.4 834.2c-0.9-2.1-2.8-2.6-4.8-2.8-1.3-0.1-2.4-0.4-3.3-1.5-0.9-1.2-2.4-1.3-3.8-1.5-0.5-0.1-1.4-0.2-1.6-0.5-1.2-2.9-4.1-2.5-6.6-3.2-0.6-1.2-0.9-2.8-2.9-2.7-0.3 0-0.8-0.4-1-0.7-1.3-1.8-3.3-2.4-5.6-2.9-0.3-0.6-0.5-1.5-1-2.1-0.4-0.4-1.2-0.6-1.9-0.7-1.5-0.3-0.8-2-1.9-2.5-0.8-0.4-2.2-0.1-2.5-1.2-0.3-1.4-1-2.1-2.5-2.3-1.4-0.3-0.6-2-1.6-2.7-0.8-0.5-2.3 0-2.5-1.2-0.3-1.9-1.4-2.6-3.2-2.7-0.5-2.3-1-4.3-3.1-5.7-0.7-0.4-0.8-1.7-1.2-2.7-0.7-0.2-1.5-0.5-2.3-0.8-0.1-0.3-0.3-0.7-0.4-1.1-0.4-1.7-0.4-3.5-2.4-4.5-0.5-0.2-0.6-1.2-0.9-1.8-0.4-0.7-0.6-1.6-1.1-2.1-1.5-1.1-2-2.5-2.3-4.2-0.1-1-0.3-1.9-0.5-2.8-0.1-0.5-0.5-1.1-0.9-1.2-1.5-0.5-1.7-1.7-1.8-3-0.1-1.1-0.1-2.2-0.3-3.3-0.3-1.4-0.1-3-2-3.8-0.4-0.2-0.5-1.2-0.7-1.8l-0.9-4.8c-0.1-0.4-0.1-0.9-0.4-1.2-2.6-2.2-2.1-5.2-2.2-8-0.2-4.1-0.2-8.2-0.2-12.3V343.1c0-5.1 0.1-10.2 0.3-15.2 0-1.6 0.2-3.1 1.6-4.5 1.3-1.3 1.6-3.4 1.7-5.4 0.1-1.5-0.1-3 1.8-3.8 0.4-0.2 0.6-1.2 0.7-1.8 0.3-1.8 0.4-3.5 0.7-5.3 0.1-0.6 0.5-1.6 0.9-1.7 1.9-0.5 1.8-2 2-3.3 0.3-2.2 0.7-4.3 2.8-5.7 0.5-0.3 0.6-1.2 0.8-1.8 0.2-0.5 0.2-1.3 0.6-1.5 2.5-1.1 2.5-3.5 3-5.8 0.7-0.2 1.4-0.5 2.5-0.8 0.5-1.4 0.9-3 2.4-4.3 1.1-0.9 1.4-2.6 2.3-4.3 0.8-0.4 2.6-0.4 2.7-2.5 0.1-1.4 2-0.6 2.8-1.5 0.7-0.8 0-2.4 1.7-2.6 1.2-0.1 1.8-0.7 2-1.8 0.1-0.7 0.5-1.3 1.3-1.4 1.3-0.1 2-0.7 2.3-2 0.1-0.4 0.7-0.9 1.2-1 1.2-0.2 2.1-0.6 2.4-1.9 0.1-0.3 0.5-0.8 0.8-0.8 2.3-0.5 4.1-1.6 5.7-3.2 0.5-0.5 1.6-0.5 2.3-0.7 0.4-0.8 0.7-1.6 1-2.3 1.3-0.3 2.6-0.5 3.8-0.8 0.5-0.1 1.4-0.2 1.5-0.6 0.8-2.3 3.2-1.9 4.9-2.7 1.4-0.6 2.5-1.7 3.9-2.3 1.3-0.5 2.8-0.4 4.1-0.9 0.8-0.3 1.4-1.3 2.2-2.1 1.7-0.2 3.5-0.2 5.3-0.5 1.1-0.2 2.6-0.4 3.1-1.1 1.2-1.8 2.9-1.6 4.5-1.7 2.8-0.2 5.7-0.2 8.5-0.4 1.7-0.1 3.3-0.2 4.7-1.4 0.7-0.6 2.1-0.8 3.2-0.8 4.5-0.2 9.1-0.3 13.6-0.4h568.1c5.3 0 10.5 0.1 15.8 0.2 2.2 0.1 4.5 0 6.4 1.7 0.6 0.6 1.9 0.6 2.8 0.6 3.5 0.2 7.1 0.3 10.7 0.5 1 0 2.1-0.1 2.7 0.8 1.1 1.5 2.8 1.8 4.5 2 1.6 0.2 3.1 0.3 4.9 0.5 0.4 0.6 0.9 1.2 1.5 2 1.3 0.3 2.6 0.7 4 0.9 1 0.2 1.9 0.3 2.4 1.3 0.7 1.3 2.2 1.1 3.4 1.5 0.8 0.3 2.1 0.2 2.4 0.7 1.4 2.5 3.9 2.4 6.3 2.8 1.1 0.9 1 3.3 3.4 3 0.3 0 0.7 0.4 1 0.7 1.2 1.5 2.9 2.1 4.7 2.5 0.4 0.1 1.1 0.4 1.1 0.5-0.2 2.6 3.6 1.6 3.7 3.8 0.1 0.8 0.5 1.3 1.3 1.4 1.3 0.1 2.1 0.6 2.2 2 0.2 1.7 2.3 0.8 2.9 2 0.5 0.9 0.2 2.3 1.8 2.5 1.2 0.1 1.7 0.7 1.9 1.8 0.1 0.4 0.6 1.1 1 1.2 1.8 0.2 2.1 1.4 2.6 2.8 0.3 1 1.3 1.8 1.9 2.7 0.5 0.7 1.2 1.3 1.2 2.1 0.1 1.7 1.4 1.9 2.7 2.3 0.3 1.1 0.7 2.2 1 3.4 0.2 0.5 0.3 1.3 0.6 1.4 2 0.6 2.3 2.2 2.6 3.8 0.1 0.4 0.5 0.7 0.8 0.9 1.4 1 1.7 2.4 1.9 3.9 0.2 1.3 0.7 2.6 1.1 3.9 2.5 0.8 2.1 2.9 2.3 4.8 0.1 0.8 0.3 1.6 0.3 2.4 0.1 1.7 0.9 2.8 2.5 3.4 0.1 1.4 0.2 2.6 0.3 3.8 0.2 1.8 0.5 3.6 2 4.8 0.8 0.7 1 1.6 1.1 2.6 0.1 1.9 0.2 3.8 0.3 5.8 0.1 4 0.1 8 0.1 11.9v392.7c0 5.4-0.1 10.7-0.2 16.1 0 1.8-0.2 3.4-1.7 4.9-1 1-1.1 2.7-1.5 4.2-0.3 1.2-0.2 2.4-0.4 3.9-1.9 0.5-2.4 2.1-2.6 3.7-0.2 1.5-0.3 3-0.5 4.5-0.1 0.5-0.3 1.3-0.6 1.5-2.1 0.6-2.3 2.4-2.5 4-0.3 2.1-0.6 4-2.6 5.4-0.4 0.3-0.4 1-0.6 1.5-0.2 0.5-0.2 1.4-0.5 1.5-2.6 1.1-2.7 3.6-3.3 5.8-1 0.8-2.9 0.5-2.9 2.5 0 0.6-0.6 1.3-1 1.7-1.5 1.4-2.6 2.9-2.6 5.1-1.8 0.2-3.3 0.7-3.3 2.7-1 0.6-2.3 1-2.9 1.9-0.6 0.8-0.4 2.2-2 2.3-1 0-1.4 0.7-1.6 1.6-0.1 0.7-0.5 1.3-1.3 1.4-1.3 0.1-2.1 0.6-2.3 2-0.1 0.4-0.7 0.8-1.2 0.9-0.9 0.2-1.7 0.4-1.9 1.4-0.2 1.1-0.7 1.6-1.9 1.8-1.6 0.2-2.9 1.1-4 2.1-0.4 0.4-0.8 0.8-1.3 1.1-0.7 0.4-1.6 0.5-2.2 1-0.5 0.4-0.6 1.2-0.8 1.7-1.4 0.3-2.6 0.6-3.9 1-0.5 0.1-1.4 0.3-1.5 0.6-0.8 2.4-3 2.1-4.8 2.7-0.5 0.2-1.4 0.2-1.6 0.5-1.2 2.3-3.6 1.9-5.5 2.4-1.4 0.3-2.3 1-2.8 2.3-1.4 0.2-2.8 0.4-4.2 0.5-3.6 0.4-3.6 0.4-6.5 2.8-3.7 0.2-7.5 0.3-11.4 0.5-1.7 0.1-3.2 0.2-4.8 1.3-1.1 0.8-2.9 0.9-4.5 1-4.7 0.2-9.4 0.2-14.1 0.2H230.6c-5.5 0-11.1-0.1-16.6-0.2-2.1-0.1-4.2 0-6-1.6-0.7-0.6-2.1-0.6-3.2-0.7-3.4-0.2-6.8-0.3-10.2-0.5-1.3 0-2.5-0.1-3.3-1.4-0.8-1.2-2.2-1.2-3.4-1.4-1.7-0.5-3.6-0.6-5.5-0.8z m302.3-472.6c-1.5-0.5-2.9-0.8-3-2.6-0.1-1.5-1.9-0.9-2.6-1.7-0.6-0.8-0.2-2.4-1.8-2.5-1.3-0.1-2-0.8-2.3-2-0.1-0.4-0.7-0.8-1.2-0.9-0.9-0.2-1.6-0.6-1.8-1.5-0.2-1.1-1-1.5-2.1-1.6-0.5-0.1-1.2-0.3-1.5-0.7-1.5-2.1-4-2.4-5.9-3.1-0.5-1-0.9-1.7-1.2-2.3-2-0.3-3.6-0.6-5.4-0.8-0.4-0.7-0.9-1.3-1.3-2.1-1.3-0.2-2.5-0.6-3.8-0.6-1.7 0-2.3-1.4-3.3-2.2-0.4-0.3-1.1-0.3-1.6-0.4-1.8-0.2-3.7-0.3-5.5-0.4-0.9-0.1-1.7-0.2-2.3-0.9-1.1-1.5-2.8-1.8-4.5-1.9-2.7-0.1-5.4-0.1-8.1-0.2-14.5-0.6-29-0.3-43.5 0.2-1.6 0.1-3.1 0-4.1 1.7-0.3 0.5-1.2 0.7-1.8 0.9-1.3 0.2-2.5 0.3-3.8 0.4-1.9 0.2-3.9-0.1-5.3 1.9-0.5 0.7-2 0.8-3.1 1.1-1.1 0.3-2.2 0.3-3.4 0.5-0.5 0.1-1.4 0.3-1.5 0.6-0.5 2-2.3 1.6-3.7 2.1-1.4 0.5-3.2 0.5-3.6 2.4-0.1 0.3-1 0.5-1.5 0.5-1.2 0.1-1.8 0.6-2 1.7-0.1 0.7-0.7 1.2-1.5 1.3-0.9 0.1-1.7 0.3-2 1.3-0.3 0.9-1 1.3-1.9 1.4-3.2 0.5-4.2 3.8-6.8 5.1-1 1.9-1.8 4-4.1 4.9-0.2 0.1-0.3 0.5-0.4 0.7 0 1.3-0.7 2-2 2.3-0.4 0.1-0.8 0.7-0.9 1.2-0.2 0.8-0.3 1.8-1.2 2-1.5 0.5-1.7 1.7-2.1 2.8-0.3 0.9-0.5 1.9-0.7 2.7l-2.2 1.1c-0.7 2.5-0.4 5.4-3.2 6.9-0.3 0.2-0.3 0.7-0.4 1.1-0.2 1.1-0.3 2.2-0.5 3.3-0.2 0.9-0.1 2-0.6 2.8-0.5 0.7-1.5 1.1-2.3 1.7-0.2 2.5-0.3 5-0.6 7.4-0.2 1.2-0.4 2.7-1.2 3.4-1.6 1.2-1.6 2.8-1.7 4.4-0.2 4-0.3 8-0.5 11.9 0 0.9-0.1 2.1-0.7 2.7-2.1 2-2.2 4.4-2.2 6.8-0.1 4.7-0.1 9.3-0.2 14 0 1.4-0.1 2.7-0.2 4.2-2.7 1-5.1 2.3-7.7 2.7-2.9 0.5-3.9 2.9-5.8 4.2 0.2 1.8-1.5 2.1-2.5 2.9-0.3 2.9-0.5 5.8-0.9 8.6-0.2 1.3-0.2 2.7-1.7 3.6-0.5 0.3-0.7 1.2-0.7 1.8-0.1 5.8-0.1 11.5 0 17.3 0 0.6 0.2 1.6 0.7 1.8 1.7 0.9 1.7 2.5 1.9 3.9 0.3 2.2 0.5 4.4 0.7 6.5 0.1 0.6 0.3 1.7 0.7 1.8 2.1 0.7 1.6 2.4 1.9 3.8 0.2 0.9 0.3 2 0.8 2.7 0.4 0.6 1.4 0.8 2.1 1.1 0.3 1.7 0.7 3.3 1 4.8 0.9 0.4 1.7 0.7 2.4 0.9 0.8 2.2 0.8 4.8 3.5 5.9 0.4 0.2 0.3 1 0.6 1.5 0.3 0.4 0.7 1.1 1.1 1.1 2.1 0 2.1 1.9 2.8 3.1 2.8 0 4.9 1.3 6.4 3.2 3.2 0.4 6.2-0.1 9.1 0.5 0.4 1.4 0.7 2.6 1.1 3.8 0.2 0.5 0.5 1.2 0.9 1.3 1.7 0.6 1.8 1.9 2 3.3 0.2 1.2 0.6 2.4 1.8 3.2 0.5 0.3 1.1 1.1 1.1 1.6 0 2 1.5 2.4 2.8 2.9 0.5 1.8 0.9 3.4 1.3 4.9l2.1 0.7c0.6 1.1 0.9 2.4 1.7 3.3 1.5 1.5 2.5 3.3 2.8 5.3 1 0.4 1.7 0.7 2.6 1 0.2 0.7 0.4 1.5 0.7 2.3 1.1 0.7 2.8 0.8 2.9 2.6 0 0.3 0.4 0.8 0.7 0.9 2.4 0.6 2.5 3.7 5 4.1 1.2 2.1 2.4 4.3 4.4 5.8-0.1 1.9 1.6 2.3 3 2.9 0.7 4.2 0.6 8.3 0.3 12.4-0.1 1.9-1.3 2.6-2.6 2.9-0.6 1.8-1.2 3.4-1.6 4.6-1.9 1.2-4 1.4-5.2 3.1-1.3 1.9-3.8 0.7-5.4 1.7-0.6 0.4-1.1 0.9-1.7 1.2-0.7 0.4-1.5 0.8-2.2 0.9-1.4 0.2-2.8 0.2-4.3 0.2-8.1 0-16.2 0-24.3 0.1-6.1 0.1-12.2 0.3-18.4 0.4-1 1.8-2.6 2.5-4.5 2.6-1 0.1-2 0.2-3 0.2-1.5 0.1-3.1 0.1-3.9 1.8-0.2 0.3-0.9 0.5-1.5 0.6-0.8 0.2-1.7 0.2-2.5 0.4-2.1 0.3-4.3 0.3-5.4 2.5-0.2 0.3-1 0.4-1.5 0.6-1.2 0.4-2.4 0.8-3.6 1.1-1.1 2.3-4.9 1.5-5.5 4.4 0 0.2-0.5 0.4-0.7 0.4-3.3 0-4.7 3.4-7.6 3.9-0.8 1.6-1.9 2.9-3.9 3.2-0.2 0-0.3 0.5-0.4 0.7-0.1 1.3-1 1.8-2.2 2.1-0.4 0.1-1 0.7-1 1.1-0.2 1.3-1 1.8-2.2 2.1-0.4 0.1-1.1 0.6-1.1 1-0.1 2-2.2 1.9-2.6 2.3-1 2.1-1.6 3.4-2.3 4.8-2 0.5-2.1 2.3-2.4 3.8-1 0.4-1.7 0.7-2.5 1-0.4 1.7-0.7 3.3-1.1 5-1.7 0.3-2.7 1.3-2.7 3.1 0 1.1-0.4 2.1-0.5 3.1-1.3 0.6-2.5 1-2.6 2.6 0 1-0.2 1.9-0.4 2.8-0.3 1.7 0 3.6-2.2 4.5-0.5 0.2-0.7 1.4-0.8 2.2-0.3 2.6-0.4 5.2-0.7 7.8-0.1 0.8-0.1 1.8-0.6 2.3-1.6 1.6-1.6 3.5-1.6 5.4-0.1 10.4-0.1 20.9-0.2 31.3 0 1.1 0 2.2 0.2 3.3 0.1 0.8 0.4 1.7 0.9 2.2 1.1 0.9 1.4 2 1.5 3.3 0.1 1.2 0.4 2.4 0.6 3.4 1.3 0.6 2.8 0.7 2.8 2.4 0 0.5 0.4 1.1 0.8 1.3 1.5 0.7 2.2 2.1 3 3.4 1 1.6 2.4 2.9 4.3 3 1.7 0.1 1.9 1.4 2.6 2.4 1.3 0.2 2.7 0.4 4.1 0.7 0.7 0.1 1.7 0.2 1.9 0.7 1.2 2.1 3.3 1.9 5.3 2 3.1 0.1 6.3 0.1 9.4 0.1h302.1c1.7 0 3.4 0 5.1-0.1 0.7 0 1.5-0.3 1.9-0.7 1.2-1.4 2.9-1.6 4.6-1.8 1.7-0.3 3.3-0.5 4.6-0.7 0.7-0.9 1.2-2.1 1.7-2.1 2.7-0.3 3.2-3.2 5.6-4 0.6-0.2 0.7-1.9 1.2-2 2.3-0.4 1.9-2.5 2.6-3.7 0.9-0.4 1.7-0.7 2.4-1 0.2-1.8 0.4-3.5 0.5-5.1 0.2-1.6 0.2-3.2 1.6-4.5 1-1 1.3-2.4 1.2-3.8 0-8.5 0-17-0.1-25.5 0-1-0.2-2.3-0.9-3.1-1.1-1.3-1.4-2.7-1.5-4.2-0.3-2.9-0.4-5.7-0.7-8.6-0.1-1.8-0.3-3.5-0.4-5.2-1-0.7-1.8-1.2-2.5-1.8-0.2-1.9-0.4-3.6-0.5-5.4-0.1-1.7-0.9-2.9-2.5-3.3-0.4-1.9-0.9-3.6-1.2-5.2-0.9-0.5-1.6-0.9-2.3-1.3-0.5-2.3-0.6-4.7-3.1-6-0.3-0.2-0.3-1-0.4-1.5-0.1-0.4-0.3-0.8-0.4-1.1-0.8-0.3-1.6-0.6-2.5-1-0.1-3.7-3.9-5.1-5.2-8.1-0.1-0.2-0.6-0.1-0.8-0.3-0.4-0.3-1.1-0.7-1.1-1.1-0.1-1.6-1.2-2-2.5-2.2-1.4-0.3-0.7-2-1.7-2.6-0.9-0.6-2.4-0.1-2.8-1.5-0.2-1.1-1.1-1.5-2.1-1.8-1.7-0.6-3.6-0.9-4.4-2.8-0.1-0.2-0.5-0.4-0.7-0.4-2 0-2.6-1.3-3-2.9-2.6-0.1-4.9-0.6-6.4-2.8-0.3-0.4-1.3-0.4-1.9-0.6-1.2-0.4-2.6-0.7-3.4-1.5-1.2-1.2-2.5-1.6-4.1-1.7-1.5-0.1-3.2 0.1-3.9-1.9-0.1-0.3-0.9-0.6-1.4-0.6-1.4-0.2-2.8-0.2-4.2-0.4-1.7-0.3-3.8 0-4.8-2-0.2-0.4-1.3-0.5-1.9-0.6-2-0.2-4-0.3-6-0.3-11.5-0.1-23-0.2-34.6-0.2-1.6 0-3.1 0-4.7-0.1-0.7-0.1-1.5-0.2-2-0.6-1.9-1.7-4.1-2.3-6.6-2.4-1.1-0.1-2.5-0.3-2.9-1.5-0.6-1.8-2.4-1.7-3.5-2.2-0.5-1.7-0.9-3.2-1.3-4.6-0.8-0.4-1.6-0.8-2.5-1.2-0.5-4.9-0.6-9.8 0.1-14.7 0.9-0.3 1.6-0.6 2.6-1 0.4-2.1 1.2-3.9 3.3-5.3 1.3-0.9 1.5-3.1 3.6-3.5 0.2 0 0.3-0.4 0.4-0.7 0.2-1.3 0.8-1.9 2.2-2.1 0.4 0 1-0.6 1.1-1.1 0.2-1.2 0.8-2 2.2-2.1 0.8-0.1 1.1-0.8 1.3-1.5 0.1-0.5 0.4-1.3 0.7-1.4 1.8-0.5 2.1-2.1 2.6-3.5 0.5-1.2 0.5-2.8 2.4-3 0.3 0 0.8-0.9 0.8-1.3 0-1.8 1.7-1.9 2.6-2.7 0.4-1.7 0.8-3.3 1.1-4.7 1-0.4 1.7-0.7 2.4-1 0.9-4.1 0.9-4.1 3.4-6.1 0.6-1.8 1.1-3.3 1.7-4.9 1.9-0.6 2-2.4 2.5-4.1 2.1 0 4.1 0 6.1-0.1 1.6 0 3.1-0.1 4.7-0.3 0.6-0.1 1.4-0.5 1.7-1 0.6-1.1 1.2-1.8 2.6-1.8 0.8 0 1-0.7 1.4-1.3 0.3-0.5 0.8-1.2 1.4-1.3 1.3-0.3 1.6-1.2 2.1-2.2 0.4-0.8 1.8-1.1 2.6-1.7 0.3-0.2 0.2-0.8 0.4-1.1 0.3-0.6 0.6-1.4 1.1-1.6 1.5-0.7 1.8-2.1 2.2-3.4 0.2-0.8 0.3-1.6 0.5-2.1 1-0.5 1.7-0.8 2.5-1.2 0.3-1.7 0.5-3.4 0.8-5.3 2.4-0.3 2.8-2.3 3-4.2 0.1-1.1 0.2-2.2 0.2-3.3 0-0.9 0.2-1.6 0.9-2.2 1.6-1.3 1.9-3 1.9-4.8v-23.9c0-1.2-0.2-2.7-0.9-3.5-1.7-2-1.9-4.2-2.1-6.5 0-0.8-0.2-1.7-0.5-2.4-0.2-0.6-0.7-1.5-1.2-1.5-2-0.3-1.7-2.3-2.6-3.3-1.4-0.2-2.7-0.6-3.9-0.5-1.7 0.2-2.3-1.4-3.5-1.8-0.4 0.1-0.7 0.1-0.9 0.3-0.4 0.2-0.7 0.5-1 0.7-1.2 0.6-1.9 0.4-2.4-0.7-0.7-1.4-1-2.8-1-4.4 0-4.1-0.1-8.2-0.3-12.3 0-0.9-0.1-2.2-0.6-2.7-1.7-1.4-1.5-3.2-1.7-4.9-0.2-3.1-0.3-6.3-0.4-9.5-0.1-1.6-0.2-3.3-0.4-4.9-0.2-1.1-0.3-2.2-1.5-2.8-0.9-0.4-0.9-1.3-1-2.1-0.2-1.9-0.2-3.8-0.5-5.7-0.2-1.6-0.3-3.3-1.9-4.4-0.5-0.3-0.8-1.1-0.9-1.7-0.3-1.5-0.3-3-0.5-4.6-3.8-1.8-2.7-5.7-3.8-8.6-0.8-0.4-1.6-0.7-2.2-1-0.2-0.3-0.3-0.4-0.3-0.5-0.4-2.2-0.2-4.8-3-5.9-0.2-0.1-0.4-0.5-0.3-0.7 0.2-2-1.3-2.5-2.9-2.8-0.8-1.9-1.2-3.4-1.6-5.2z m61.2 79.9h234.7c2.3 0 4.5-0.2 6.8-0.3 0.3 0 0.5-0.2 0.9-0.4 0.3-0.7 0.6-1.4 0.9-2.2 0.9-0.2 1.9-0.5 2.8-0.7 0.6-1.3 0.5-3 2.6-2.9 0.2 0 0.7-0.6 0.7-0.8 0-2.1 1.9-2.1 3.3-2.6 0.2-1.9 0.3-3.6 0.5-5.5 2.2-0.8 2.8-2.5 2.8-4.6v-1.6-29.6c0-1.4-0.1-2.7-0.2-4.1-1.5-0.6-2.6-1.3-2.7-2.9-0.1-1.8-0.3-3.6-0.5-5.3 0-0.4-0.3-0.7-0.4-1-0.9-0.2-1.7-0.5-2.3-0.6-0.4-1.2-0.7-2-0.9-2.8-0.9-0.2-1.6-0.3-2.2-0.4-0.5-0.9-0.9-1.7-1.4-2.6-1.7-0.1-3.2-0.3-4.8-0.4-2.1-0.1-3.9-0.6-4.6-2.9-3.7 0-7.2-0.1-10.8-0.1H525c-1.3 0-2.6-0.1-3.8 0-0.8 0.1-1.6 0.4-2.3 0.6-0.3 2.9-0.3 5.6 0.2 8.2 1.1 0.4 2 0.8 2.8 1.2 0.1 1.9 0.2 3.7 0.3 5.3 3.1 2.9 3.1 2.9 3.3 6.9 0 1.4 0.1 2.7 0.2 4.1 0 0.4 0.2 0.8 0.3 1.1 0.9 0.5 1.7 0.9 2.5 1.3 0.7 4.8-0.2 9.5 0.8 14.1 0.5 0.2 0.9 0.4 1.3 0.6 0.4 0.2 0.7 0.4 1.2 0.7 0.1 1 0.2 2.1 0.3 3.2 0.1 3 0.1 6 0.1 9 0.1 3.9 1 4.9 4.9 6 0.4 0.1 0.8 0.3 1.1 0.4 0.5 1.3 0.5 2.8 2.2 3.3 0.5 0.2 0.9 1 1.1 1.6 0.4 1.1 0.8 2.3 1.1 3.4 2.1 0.6 2.1 0.6 3.3 3.3z m-36.8 133h270.5c1.1 0 2.3-0.1 3.4-0.4 0.6-0.1 1.4-0.5 1.7-1 0.7-1.1 1.6-1.4 2.8-1.4 1.4-0.1 2.8-0.4 3.8-0.5 1-1 0.6-2.6 1.9-2.6 2.4 0 2-2 2.6-3 0.9-0.3 1.7-0.5 2.6-0.8 0.2-2.1 0.4-4.1 0.7-6.2 0.1-0.8 0.4-2 0.9-2.1 1.8-0.7 1.7-2 1.7-3.4v-31.7c0-1.3-0.2-2.3-1.3-3.3-1.2-1-1.5-2.6-1.6-4.1-0.1-1.3-0.2-2.7-0.3-4.3-1.9 0-3.2-0.5-3.3-2.5 0-0.2-0.6-0.7-1-0.7-2 0-1.6-2-2.3-2.7-1.3-0.5-2.8-0.5-3.3-1.3-1.4-2-3.3-2.4-5.5-2.4H557c-1.3 0-2.6 0-3.8 0.1-0.3 0-0.5 0.2-0.9 0.4l-0.9 2.1c-0.9 0.4-1.8 0.7-2.5 1-0.6 2.9 0.1 5.7-1 8.2-0.9 0.3-1.7 0.6-2.5 0.8-0.2 2-0.4 3.7-0.6 5.4-1 0.4-1.7 0.7-2.5 1.1-0.2 1.7-0.3 3.3-0.5 5-1 0.3-1.9 0.6-3 1 0.2 2.2-1.2 3.2-2.9 3.6-0.4 1.7-0.8 3.2-1.1 4.7-0.8 0.3-1.6 0.6-2.4 0.8-0.3 0.9-0.7 1.8-0.9 2.5-1 0.2-1.8 0.4-2.5 0.6-0.3 1-0.5 1.7-0.7 2.4-1 0.4-1.9 0.7-2.7 0.9-0.2 0.9-0.4 1.5-0.6 2.2-2.4 0.7-5.3 0.4-6.6 3-0.1 0.2-0.5 0.3-0.8 0.3-2.1-0.2-2.5 1.4-2.8 2.9-2 0.2-3.9 0.3-5.8 0.5-0.5 1.7-0.8 3.5-3.1 4v16.9c2.1 1.6 2.1 1.6 3.2 4zM798 640c-1-0.7-2.5-0.7-2.7-2.3-0.1-0.5-0.8-1.1-1.3-1.3-0.8-0.3-1.6-0.5-2-1.3-0.4-0.8-1.1-1.1-2-1.3-1.5-0.3-3.1-0.6-4.6-0.9-0.9-0.2-2.1-0.4-2.7-1-1-1.1-2.1-1.2-3.4-1.3-1.8 0-3.7-0.1-5.5-0.1H605.3c-0.8 0-1.6 0.1-2.4 0.2-1.1 2.9-0.7 5.6-0.3 8.3 0.8 0.4 1.6 0.7 2.5 1.1 0.3 1.3 0.5 2.6 0.9 4 0.1 0.5 0.3 1.3 0.7 1.4 2 0.6 1.9 2.2 2.2 3.7 0.3 1.5 0.2 3 2 3.8 0.4 0.2 0.6 0.9 0.7 1.4 0.2 0.8 0.2 1.7 0.4 2.4 0.6 1.8 0 4.2 2.4 5.4 0.4 0.2 0.5 1.2 0.5 1.9 0.2 2.2 0.3 4.4 0.5 6.6 0.2 2.3 0.2 4.7 2.2 6.5 0.4 0.3 0.5 1 0.6 1.5 0.2 1.6 0.5 3.3 0.5 4.9 0.1 6 0 12.1 0 18.1 0 1.9 0 3.8 1.5 5.7 1.7 0.1 3.5 0.3 5.4 0.3h149.7c1.6 0 3.1 0 4.7-0.1 0.7 0 1.6-0.2 2-0.6 1.5-1.9 3.7-1.8 5.8-2.1 1.8-0.3 3.7-0.3 4.7-2.2 0.2-0.5 1.2-0.6 1.8-1 0.4-0.3 1.1-0.6 1.2-1 0.2-1.7 1.9-1.9 2.9-2.6 0.8-2.3 0.4-5.1 3.1-6.5 0.3-0.1 0.3-0.7 0.4-1.1 0.1-1.1 0.2-2.2 0.2-3.3V651c0-2 0.4-4.2-2.1-5.4-0.4-0.2-0.4-1-0.6-1.5-0.7-1.5-1-2.8-1.4-4.1z"
                fill="#3FA9F5"
                p-id="1872"
              />
            </svg>缴费单位
          </span>
        </p>
        <span class="cell_value">
          {{name}}
          <i class="iconfont right_jiantou">&#xe6cf;</i>
        </span>
      </li>
    </el-card>

    <p class="tit_tip">
      <span>已绑定的用户</span>
      <span v-if="datas.length" @click="edit" class="edit_user">{{editFlag?'返回':'编辑'}}</span>
    </p>
    <el-card class="box-card">
      <li
        class="cell_item"
        v-for="(item,index) in datas"
        @click="goPage(item,index)"
        :key="index"
      >
        <p class="title_tip">
          <svg
            t="1600063231720"
            class="icon"
            viewBox="0 0 1238 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6110"
            width="20"
            height="20"
          >
            <path
              d="M1033.382698 186.153674v213.396838a144.002977 144.002977 0 0 0 96.113116-135.644279V186.153674h-96.113116m-47.627907 316.77321h-47.627907V92.255256l48.961488-1.357396h192.940651c24.147349 0 43.865302 19.194047 44.555907 43.341396l0.166698 5.643907v124.02307c0 132.000744-107.019907 239.020651-238.996837 239.020651M129.309767 186.153674v77.752559a143.979163 143.979163 0 0 0 96.113117 135.644279V186.153674H129.309767m191.368931 316.77321h-47.627907c-132.000744 0-238.996837-107.019907-238.996838-239.020651V135.596651c0-24.123535 19.194047-43.889116 43.317582-44.555907l5.643907-0.142884h236.282046l1.38121 48.985303v363.043721"
              fill="#D26C9E"
              p-id="6111"
            />
            <path
              d="M634.427535 975.014698h-10.049488a42.603163 42.603163 0 0 1-42.603163-42.626977v-161.458605h95.255814v161.458605a42.626977 42.626977 0 0 1-42.603163 42.626977"
              fill="#7B659D"
              p-id="6112"
            />
            <path
              d="M651.02586 248.212837l30.410419 61.654326c3.524465 7.120372 10.311442 12.073674 18.170047 13.19293l68.036465 9.882791a24.123535 24.123535 0 0 1 13.359628 41.126697l-49.223442 48.008931a24.028279 24.028279 0 0 0-6.929861 21.337302l11.62121 67.774512a24.123535 24.123535 0 0 1-35.006512 25.409488L640.595349 504.59386a24.242605 24.242605 0 0 0-22.432744 0l-60.844652 32.005954a24.123535 24.123535 0 0 1-35.006511-25.409488l11.645023-67.774512a24.099721 24.099721 0 0 0-6.92986-21.337302l-49.247256-48.008931a24.123535 24.123535 0 0 1 13.359628-41.126697l68.036465-9.882791c7.882419-1.119256 14.669395-6.072558 18.170046-13.19293l30.434233-61.654326a24.123535 24.123535 0 0 1 43.246139 0"
              fill="#D26C9E"
              p-id="6113"
            />
            <path
              d="M320.678698 105.876837V414.60093c0 170.22214 138.47814 308.700279 308.724093 308.700279 170.22214 0 308.724093-138.47814 308.724093-308.700279V105.876837H320.678698m315.582511 712.632558c-225.970605 3.786419-410.838326-188.65414-410.838325-414.624744V55.319814c0-24.147349 19.21786-43.889116 43.341395-44.555907l5.620093-0.142884h714.275721c24.123535 0 43.865302 19.194047 44.555907 43.317582l0.166698 5.643907V414.60093c0 220.445767-177.533023 400.241116-397.121489 403.908465"
              fill="#7B659D"
              p-id="6114"
            />
            <path
              d="M603.159814 1010.735628h-10.049488a42.626977 42.626977 0 0 1-42.603163-42.626977v-117.283721c-168.555163-21.051535-305.294884-150.885209-344.587907-315.15386-114.92614-17.360372-203.133023-116.259721-203.133023-236.043907V171.317581c0-20.122791 13.383442-37.197395 31.815441-42.698418a44.746419 44.746419 0 0 0-0.547721 6.977488v128.309582c0 119.665116 87.94493 218.802605 202.728187 236.282046 39.340651 164.292465 176.389953 294.411907 344.992744 315.415814v116.783628c0 23.552 19.051163 42.626977 42.603163 42.626977h10.049488c3.786419 0 7.477581-0.500093 11.002046-1.452651a42.650791 42.650791 0 0 1-42.269767 37.173581m73.870884-164.197209v-30.767628a403.051163 403.051163 0 0 0 239.401674-117.188465 404.122791 404.122791 0 0 1-239.401674 147.956093M225.422884 399.550512a143.955349 143.955349 0 0 1-31.267721-15.526698V221.874605H129.309767v-35.720931h96.113117v213.396838m0-308.652652H194.155163a44.603535 44.603535 0 0 1 31.815442-42.579348 45.29414 45.29414 0 0 0-0.547721 7.001302v35.578046"
              fill="#F9DEE5"
              p-id="6115"
            />
            <path
              d="M236.78214 500.188279c-114.783256-17.479442-202.728186-116.61693-202.728187-236.282046V135.596651c0-2.381395 0.190512-4.715163 0.547721-6.977488 3.643535-1.095442 7.525209-1.738419 11.525954-1.857489l5.643907-0.142883h142.383628V91.040744v-0.142884h31.267721V403.884651c0 32.982326 3.929302 65.250233 11.359256 96.303628M98.042047 221.874605v77.752558a144.026791 144.026791 0 0 0 96.113116 135.644279v-51.247628c9.668465 6.38214 20.170419 11.597395 31.267721 15.526698V186.153674H129.309767v35.720931H98.042047"
              fill="#D26C9E"
              p-id="6116"
            />
            <path
              d="M634.427535 975.014698h-10.049488a42.603163 42.603163 0 0 1-42.603163-42.626977v-116.783628c15.717209 1.952744 31.720186 2.95293 47.937488 2.95293 2.16707 0 4.357953 0 6.548837-0.047628 13.764465-0.23814 27.362233-1.14307 40.769489-2.738604v30.767628c-10.287628 2.048-20.71814 3.691163-31.267721 4.953302v116.61693c0 1.857488-0.11907 3.667349-0.333396 5.453396-3.524465 0.952558-7.215628 1.452651-11.002046 1.452651"
              fill="#8A679E"
              p-id="6117"
            />
            <path
              d="M845.442977 634.903814a307.128558 307.128558 0 0 0 61.416186-184.605767V141.597767H320.678698v-35.72093h617.448186V414.60093c0 86.182698-35.530419 164.244837-92.683907 220.302884m171.079442-104.709954c2.976744-9.978047 5.596279-20.098977 7.810976-30.386604a238.282419 238.282419 0 0 0 124.451721-61.130419 239.473116 239.473116 0 0 1-132.262697 91.517023m60.320744-155.17172a142.883721 142.883721 0 0 0 21.38493-75.394977V221.874605h-64.845395v-35.720931h96.113116v77.752559a143.455256 143.455256 0 0 1-52.652651 111.115907"
              fill="#F9DEE5"
              p-id="6118"
            />
            <path
              d="M1024.333395 499.807256c5.572465-25.83814 8.668279-52.605023 9.001675-80.038698a145.026977 145.026977 0 0 0 43.508093-44.746418 143.455256 143.455256 0 0 0 52.652651-111.115907V186.153674h-96.113116v-59.534883h115.378604a44.532093 44.532093 0 0 1 44.555907 43.341395l0.166698 5.643907v124.02307c0 51.914419-16.550698 99.899535-44.698791 139.049674a238.282419 238.282419 0 0 1-124.451721 61.130419"
              fill="#D26C9E"
              p-id="6119"
            />
            <path
              d="M629.712372 818.557023c-16.217302 0-32.220279-1.000186-47.937488-2.95293-168.602791-21.003907-305.652093-151.123349-344.992744-315.415814a413.57693 413.57693 0 0 1-11.359256-96.303628V55.319814c0-2.381395 0.190512-4.715163 0.547721-7.001302 3.667349-1.095442 7.525209-1.714605 11.549767-1.833675l5.620093-0.142884h714.251907a44.532093 44.532093 0 0 1 44.555907 43.341396l0.166698 5.620093v31.315349h31.267721v95.255814h-31.267721v213.396837a143.526698 143.526698 0 0 0 31.220093-15.502884 402.574884 402.574884 0 0 1-16.812651 110.425302c-7.715721 2.071814-15.621953 3.762605-23.623442 5.072373a402.813023 402.813023 0 0 1-76.466605 163.316093 403.051163 403.051163 0 0 1-280.171163 119.927069c-2.190884 0.047628-4.381767 0.047628-6.548837 0.047628M289.410977 141.597767v308.70028c0 170.245953 138.501953 308.724093 308.724093 308.724093 101.090233 0 190.964093-48.818605 247.307907-124.118326a307.819163 307.819163 0 0 0 92.683907-220.302884V105.876837H320.678698v35.72093h-31.267721"
              fill="#8A679E"
              p-id="6120"
            />
            <path
              d="M681.436279 575.154605a23.813953 23.813953 0 0 1-11.216372-2.833861l-60.868465-32.005953a24.266419 24.266419 0 0 0-22.432744 0l-60.844651 32.005953a23.909209 23.909209 0 0 1-11.240187 2.833861c-14.050233 0-26.433488-12.669023-23.766325-28.243349l11.645023-67.774512a24.075907 24.075907 0 0 0-6.953674-21.337302l-49.223442-48.00893a24.099721 24.099721 0 0 1 13.359628-41.126698l12.740465-1.833674c1.190698 2.595721 2.881488 5.048558 5.143814 7.239441l49.247256 48.008931c5.667721 5.548651 8.287256 13.502512 6.92986 21.337302l-11.645023 67.774512a24.194977 24.194977 0 0 0 23.790139 28.243348 23.813953 23.813953 0 0 0 11.216372-2.83386l60.844652-32.005954a24.361674 24.361674 0 0 1 22.432744 0l60.868465 32.005954c0.714419 0.381023 1.428837 0.714419 2.143256 1.000186l1.595535 9.311256a24.171163 24.171163 0 0 1-23.766326 28.243349m43.698605-141.359628a24.052093 24.052093 0 0 1 6.644093-11.716465l24.671256-24.075907a23.742512 23.742512 0 0 1-6.715535 11.787907l-24.599814 24.004465m-168.078884-110.425303l19.456-39.435907a23.813953 23.813953 0 0 1 20.24186-13.407255l-19.408372 39.340651a24.004465 24.004465 0 0 1-18.170046 13.19293l-2.119442 0.309581"
              fill="#F9DEE5"
              p-id="6121"
            />
            <path
              d="M546.101581 539.433674c-14.050233 0-26.433488-12.669023-23.790139-28.243348l11.645023-67.774512a24.099721 24.099721 0 0 0-6.92986-21.337302l-49.247256-48.008931a23.909209 23.909209 0 0 1-5.143814-7.239441l55.296-8.049117c7.858605-1.14307 14.645581-6.072558 18.170046-13.169116l10.954419-22.242233 2.119442-0.309581c7.882419-1.119256 14.669395-6.072558 18.170046-13.19293l19.408372-39.340651 1.38121-0.023814c8.596837 0 17.193674 4.477023 21.646883 13.431069l30.410419 61.67814c3.500651 7.096558 10.287628 12.026047 18.146233 13.169116l68.060279 9.882791c14.859907 2.16707 23.028093 16.455442 20.051349 29.338791l-24.671256 24.075907a24.052093 24.052093 0 0 0-6.644093 11.716465l-24.623628 24.004465a24.052093 24.052093 0 0 0-6.929861 21.337302l10.025675 58.463256a21.62307 21.62307 0 0 1-2.143256-1.000186L640.595349 504.59386a24.171163 24.171163 0 0 0-22.432744 0l-60.844652 32.005954a23.813953 23.813953 0 0 1-11.216372 2.83386"
              fill="#D26C9E"
              p-id="6122"
            />
          </svg>
          {{item.relationShip}}
        </p>
        <span class="cell_value">
           {{useYhkh?item.customerYhkh:item.customerCode}}
          <i v-if="!editFlag" class="iconfont right_jiantou">&#xe6cf;</i>
          <span v-if="editFlag">
            <input type="checkbox" :id="'checkbox'+index" class="select-tag-input" />
            <label class="tag-label" :for="'checkbox'+index"></label>
          </span>
        </span>
      </li>
      <p class="no_data" v-if="!datas.length">暂无已绑定用户</p>
    </el-card>

    <button class="btn_bind" style="width:100%" @click="addUser">{{editFlag?'解 绑 用 户':'增 加 用 户'}}</button>
  </div>
</template>

<script>
  import {getList, getOpenId, untie, getBindReli, tbXx} from "@/api";
import cell from "@/components/cell";
import { getQueryVariable } from "@/utils";
import {getUserYhkh} from "@/api";
export default {
  data() {
    return {
      datas: [],
      thirdId: sessionStorage.getItem("thirdId"),
      companyCode: sessionStorage.getItem("companyCode"),
      editFlag: false,
      id: "",
      name: "",
      type: 1,
      state: sessionStorage.getItem("state") || "huilian",
      city: '',
      useYhkh: false
    };
  },
  mounted() {
    sessionStorage.setItem("path", this.$route.path);
    if (!this.companyCode || !this.thirdId) {
      var companyCode = getQueryVariable("state");
      var code = getQueryVariable("code");
      if (companyCode.indexOf("#") > -1) {
        companyCode = companyCode.split("#")[0];
      }
      sessionStorage.setItem("state", companyCode);
      if (companyCode != "huilian") {
        this.type = 0;
      }
      sessionStorage.setItem("companyCode", companyCode);
      sessionStorage.setItem("type", this.type);
      getOpenId({
        state: companyCode,
        code: code,
      }).then((res) => {
        var openId = res.data.openId;
        sessionStorage.setItem("thirdId", openId);
        sessionStorage.setItem("unionId", res.data.unionid);
        this.getUseYhkhFlag()
        this.getBindReli();
      });
    } else {
      this.getBindReli();
      this.getUseYhkhFlag()
    }
  },
  components: {
    cell,
  },
  methods: {
    getList() {
      getList({
        companyCode: sessionStorage.getItem("companyCode"),
        thirdId: sessionStorage.getItem("thirdId"),
      }).then((res) => {
        if (res && res.data) {
          this.datas = res.data;
          // alert(0)
          tbXx({}).then(res=>{

          })
        } else {
          // this.$router.push('/searchUser')
        }
      });


    },
    getUseYhkhFlag() {
      getUserYhkh({companyCode:sessionStorage.getItem("companyCode")}).then(res=>{
        sessionStorage.setItem('useYhkh',res.data.useYhkh)
        this.useYhkh = res.data.useYhkh
      })
    },
    getBindReli() {
      if (sessionStorage.getItem("state") == "huilian") {
        getBindReli(sessionStorage.getItem("thirdId")).then((res) => {
          console.log('chakan',res.data)
          if (!res.data) {
            this.$router.push("/bindComponey");
          } else {
            sessionStorage.setItem("companyCode", res.data.companyCode);
            this.name = res.data.companyName;
            this.city = res.data.city
            this.getList();
          }
        }).catch(()=>{
          this.$router.push("/bindComponey");
        })
      } else {
        this.getList();
      }
    },
    edit() {
      this.editFlag = !this.editFlag;
      this.id = "";
    },
    goPage(item,index) {
      const {customerCode, id, customerId,customerYhkh} = item
      if (!this.editFlag) {
        this.$router.push({
          path: this.$route.params.path?'/'+this.$route.params.path:'/menuList',
          query: {
            code: this.useYhkh?customerYhkh:customerCode,
            userId: customerId,
          },
        });
      } else {
        this.getUser(id, index);
      }
    },
    getUser(userId, index) {
      const item = document.getElementById(`checkbox${index}`);
      this.datas.map((v, ind) => {
        if (index !== ind) {
          document.getElementById(`checkbox${ind}`).checked = false;
        }
      });
      item.checked = !item.checked;
      let checkedFlag = item.checked;
      if (checkedFlag) {
        this.id = userId;
      } else {
        this.id = "";
      }
    },
    addUser() {
      if (!this.editFlag) {
        this.$router.push({
          path: "/searchUser",
        });
      } else {
        if (this.id) {
          untie(this.id).then((res) => {
            this.$toast("解绑成功");
            this.getList();
            this.editFlag = false;
            this.userId = "";
          });
        } else {
          this.$toast("请选择要解绑的用户");
        }
      }
    },
    goBind() {
      if(!sessionStorage.getItem('thirdId')){
        window.reload()
      }
      this.$router.push("/bindComponey");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tit_tip {
  line-height: 40px;
  color: rgb(116, 114, 114);
  font-size: 12px;
  padding: 0 3%;
  display: flex;
  justify-content: space-between;
}
.edit_user {
  color: #47c34d;
  font-size: 14px;
}
.title_tip {
  /* border-bottom: 1px solid #f1f1f1; */
  line-height: 30px;
}
.title_tip svg,
.title_tip span {
  vertical-align: middle;
  margin-bottom: 3px;
  margin-right: 5px;
}
.cell_item {
  /* height: 50px;
    line-height: 50px; */
  /* display: flex; */
  margin-top: 10px;
  background: #fff;
  justify-content: space-between;
  padding: 0 3%;
  border-bottom: 1px solid #eee8e8;
}
.cell_label {
  font-size: 12px;
  display: block;
}
.cell_value {
  /* color: #999; */
  display: flex;
  justify-content: space-between;
  margin: 0.8rem 0;
  font-size: 1rem;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.right_jiantou {
  font-size: 25px;
  clear: both;
  vertical-align: middle;
}

.select-tag-input {
  display: none;
}
.select-tag-input + label {
  background-color: #fff;
  border: none;
  border: 1px solid #c1caca;
  /* box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05); */
  padding: 9px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  vertical-align: middle;
}
.select-tag-input:checked + label {
  background-color: #26a2ff;
  border: none;
  border: 1px solid #26a2ff;
  color: #26a2ff;
}
.select-tag-input:checked + label:after {
  content: "\2714";
  position: absolute;
  transform: translateY(-50%);
  left: 0px;
  color: #fff !important;
  width: 100%;
  text-align: center;
  font-size: 1.4em;
  padding: 1px 0 0 0;
  vertical-align: text-top;
}
.tit_Name {
  background: #fff;
  line-height: 50px;
  padding: 0 3%;
  font-size: 14px;
}
.relationShip {
  color: #409eff;
  font-size: 10px;
}
.user_list {
  min-height: 90%;
  padding: 3% 3%;
}
.box-card1 {
  margin-top: 0.2rem;
}
.city svg{
  vertical-align: middle;
}
.city{
  display: flex;
  line-height: 30px;
  justify-content: space-between;
}
.city span:nth-child(1){
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/yhBind/UserList.vue